import { css } from '@emotion/css';
import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ReactComponent as Mail } from '../../assets/images/home/ic-mail.svg';
import { sendEvent } from '../../lib/google-analytics';
import { User } from '../../models/User';

interface StatusbarProps {
  user: User;
  unreadNotificationsExist: boolean;
  splashFinished: boolean;
}

export const Statusbar: React.FC<StatusbarProps> = ({
  user,
  unreadNotificationsExist,
  splashFinished
}) => {
  const { t } = useTranslation('translation');
  const history = useHistory();
  const date = getTodayString(t);

  const handleNotificationIconClick = () => {
    sendEvent('home_notification_center', 'click', 'mail_icon');
    const pageParam = history.location.search;
    history.push(`/players/home/notifications${pageParam}`);
  };

  return (
    <div
      className={css`
        flex: 0 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 44px;
        font-size: 10px;
        color: #dfd9c9;
        padding: 0 8%;
        opacity: ${splashFinished ? 1 : 0};
        transition: opacity 0.2s linear;

        button {
          margin-right: 8px;
          padding: 0;
        }
        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 40px;
          height: 24px;
          background: ${unreadNotificationsExist ? '#938666' : '#dfd9c9'};
          border-radius: 12px;
          vertical-align: middle;
          transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49);
        }
        button:active {
          .icon {
            transform: scale(0.9, 0.85);
          }
        }

        @media (min-width: 370px) {
          font-size: 12px;
        }
        @media (max-height: 580px) {
          height: 28px;
        }
      `}
    >
      <span>
        <button onClick={handleNotificationIconClick} aria-label={t('aria_to_notification_center')}>
          <span className="icon">
            <Mail />
          </span>
        </button>
        {user.name}
      </span>
      <span>{date}</span>
    </div>
  );
};

function getTodayString(t: TFunction) {
  const today = new Date();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  return t('date_md', { month, day });
}
